import countryService from "../../services/country.service";


export const state ={
    countries:[],

}
export const actions = {
    fetch_countries({commit}, page){
        return  countryService.fetch_countries(page).then(
            data => {                 
                commit ('SET_COUNTRIES', data.data);
                return Promise.resolve(data.data);
            }, error => {
                commit('AssetsFailed');
                return Promise.reject(error);
            }
        );
    },

}
export const mutations = {
    
    SET_COUNTRIES(state,countries){
        state.countries = countries
    },
    
}
export const getters = {
    get_countries(state){
        return state.countries 
    },
    

}


